import PropTypes from 'prop-types';
import React from 'react';

import './index.scss';
export default class extends React.PureComponent {
  static displayName = 'TourPage-BookingDetails-Error';

  static propTypes = {
    message: PropTypes.string.isRequired,
  };

  render() {
    return (
      <p className="TourPage-BookingDetails-Error twelve wide column">
        {this.props.message}
      </p>
    );
  }
}
